// React.
import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';

// Components.
import Header from '../layout/Header';
import ActionAlert from '../utils/ActionAlert';

// Material UI.
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

// Styles.
import useStyles from './AdminLookerStyles';

// Types interfase.
interface AdminProps {
  content?: React.ReactNode;
};


const AdminLooker = ({ content } : AdminProps) => {
  let history = useHistory();
  const classes = useStyles();

  if (content === undefined) {
    history.push('/admin/orders');
  }

  return (
    <Fragment>
      <Header />
      <CssBaseline />
      <Container className={classes.root}>
        <ActionAlert />
        <div>
          { content }
        </div>
      </Container>
    </Fragment>
  )
}

export default AdminLooker;
